import { render, staticRenderFns } from "./IconLightbulb.vue?vue&type=template&id=2e98774e"
import script from "./IconLightbulb.vue?vue&type=script&lang=js"
export * from "./IconLightbulb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports